<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="DEA01">
<div class="chapterHead">
<h2 class="chapterTitle1"><span class="bold">DEAD MAN’S GOLD</span></h2>
</div>
<div class="chapterBody">
<p class="paraNoIndent">He ran as hard as he could, giving it all he had, plowing through the snow like a bull, until he was near the rifleman, separated from him by a line of boulders. He bounded atop one of the boulders, saw the reloading man look up in shock—and Sam leaped, flying though the air with the pick in his hand, swinging down as he descended.</p>
<p class="paraNoIndent1">The man had dropped his rifle and gone for a pistol stuck into his belt, but the pistol caught and never came clear. Sam descended and brought the pick down hard, intending to strike with the flat of it and knock the man cold. But the pick had turned in his hand. The sharp, rusted prong of it hit Emmett Fish in the center of the top of his head, dug through bone, and sank into his brain….</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312943349_DEA01.vue?1d70da5f